import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventFeature extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventFeature';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            featureId: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.EventLayout) {
    //         data.EventLayout = new models.api.EventLayout(data.EventLayout)
    //     }
    //     return data
    // }
}

const servicePath = 'event-features';
const servicePlugin = makeServicePlugin({
    Model: EventFeature,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin